/* JA quick-add (cards on Home + Collection). Phone: the size panel becomes a bottom sheet with focus trap, Escape and
   focus return. All sizes: "Select a size" until chosen, then "Add to bag — $price"; submitting without a size shows an
   inline error and focuses the sizes. No work at load: everything is event-delegated. textContent only. */
(function () {
  if (window.jaQuickAdd) return; window.jaQuickAdd = 1;
  var phone = window.matchMedia('(max-width: 749px)');
  var openEl = null;
  function q(d, s) { return d.querySelector(s); }
  function sum(d) { return q(d, 'summary'); }
  function setOpenLabel(d, open) {
    var s = sum(d); if (!s) return;
    if (d.classList.contains('ja-szsheet')) { s.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
    var first = s.firstChild;
    if (!s.dataset.closedLabel) s.dataset.closedLabel = first.textContent;
    first.textContent = open ? (s.dataset.openLabel || 'Close sizes') : s.dataset.closedLabel;
    s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function close(d, restore) {
    if (!d || !d.open) return;
    d.open = false;
    if (restore !== false && sum(d)) sum(d).focus();
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.matches || !d.matches('details[data-ja-qa]')) return;
    setOpenLabel(d, d.open);
    if (d.open) {
      if (openEl && openEl !== d) close(openEl, false);
      openEl = d;
      if (phone.matches) {
        d.classList.add('is-sheet'); document.documentElement.classList.add('ja-sheet-open');
        var f = q(d, '.ja-sizes__grid input:checked') || q(d, '.ja-sizes__grid input:not([disabled])') || q(d, '[data-ja-qa-panel] a[href], [data-ja-qa-panel] button');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30);
      }
    } else {
      d.classList.remove('is-sheet');
      if (openEl === d) openEl = null;
      if (!openEl) document.documentElement.classList.remove('ja-sheet-open');
    }
  }, true);
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-ja-qa-close]');
    if (c) { e.preventDefault(); close(c.closest('details[data-ja-qa]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') { e.preventDefault(); close(openEl); return; }
    if (e.key !== 'Tab' || !openEl.classList.contains('is-sheet')) return;
    var els = Array.prototype.filter.call(openEl.querySelectorAll('.ja-sizes__panel a[href], .ja-sizes__panel button, .ja-sizes__panel input:not([disabled]), [data-ja-qa-panel] a[href], [data-ja-qa-panel] button'), function (x) { return x.offsetParent !== null || x.type === 'radio'; });
    var radios = els.filter(function (x) { return x.type === 'radio'; });
    var chk = radios.filter(function (x) { return x.checked; })[0] || radios[0];
    els = els.filter(function (x) { return x.type !== 'radio' || x === chk; });
    if (!els.length) return;
    var a = els[0], z = els[els.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target; if (!i.matches || !i.matches('form.ja-sizes__panel input[name=id]')) return;
    var f = i.form, b = q(f, '.ja-sizes__add'), er = q(f, '[data-ja-qa-err]');
    if (b) b.textContent = (b.dataset.labelAdd || 'Add to bag — ') + (i.dataset.price || '');
    if (er) er.hidden = true;
    f.classList.remove('is-invalid');
  });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form.ja-sizes__panel')) return;
    if (q(f, 'input[name=id]:checked')) { var l = q(f, '[data-ja-live]'); if (l) l.textContent = ''; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    var er = q(f, '[data-ja-qa-err]'); if (er) er.hidden = false;
    f.classList.add('is-invalid');
    var first = q(f, 'input[name=id]:not([disabled])'); if (first) first.focus();
  }, true);
  document.addEventListener('cart:updated', function () {
    if (openEl) { var l = q(openEl, '[data-ja-live]'); if (l) l.textContent = ''; close(openEl, false); }
  });
})();
